import React from 'react';

import './index.scss';

import {toJS} from 'mobx';

//material-ui
import { CircularProgress } from '@material-ui/core';

//custom components
import CustomTabs from '../../components/basic/customTabs';
import Admin from './admins';
import Warehouse from './warehouse/Warehouse'
import ClientManager from './client-manager';
import ClientUser from './client-user';
import Representative from './representative/Representative';

//other libraries

import { inject, observer } from 'mobx-react';


@inject('internal')
@inject('translate')
@observer
export default class Privileges extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.privileges)
            && toJS(this.props.internal.user.data.permissions.privileges.view)){

        this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.HEADER.PRIVILEGES)
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    tabsConfig = [
        {
            label: this.props.translate.i18n.MODULES.PRIVILEGES.ADMINS,
            url: "/privileges/admin"
        },
        {
            label: this.props.translate.i18n.MODULES.PRIVILEGES.REPRESENTATIVE,
            url: "/privileges/representative"
        },
        {
            label: this.props.translate.i18n.MODULES.PRIVILEGES.WAREHOUSE,
            url: "/privileges/warehouse"
        },
        {
            label: this.props.translate.i18n.MODULES.PRIVILEGES.CLIENT_MANAGER,
            url: "/privileges/client-manager"
        },
        {
            label: this.props.translate.i18n.MODULES.PRIVILEGES.CLIENT_USER,
            url: "/privileges/client-user"
        },
    ]

    render() {
        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }
        return (
            
            <div className={'privileges-container'}>
                {this.state.loading ?
                    <CircularProgress className={'circular-progress'} />
                    :
                    <div className={'privileges-details'}>
                        <CustomTabs
                            tabsConfig={this.tabsConfig }
                            routerData={routerData}
                            module={'/privileges'}
                            goBackNone
                            >
                            

                            {this.state.loading ? null :
                                <Admin routerData={routerData}/>
                            }
                            {this.state.loading ? null :
                                <Representative routerData={routerData}/>
                            }
                            {this.state.loading ? null :
                                <Warehouse routerData={routerData}/>
                            }
                            {this.state.loading ? null :
                                <ClientManager routerData={routerData}/>
                            }
                            {this.state.loading ? null :
                                <ClientUser routerData={routerData}/>
                            }
                            
                        </CustomTabs>


                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/privileges/index.js